import { Inertia } from '@inertiajs/inertia';
import { useForm } from '@inertiajs/inertia-react';
import usePageProps from 'app/components/hooks/usePageProps';
import Icon from 'app/components/Icon';
import { MODALS, ModalsContext } from 'app/components/Layouts/Modals';
import { ProjectType } from 'app/components/Types/ProjectType';
import { UserType } from 'app/components/Types/UserType';
import React, { useContext, useEffect } from 'react'
import route from 'ziggy-js';
import Form from '../Forms/Form';
import Select from '../Forms/Select';
import SelectMultiple from '../Forms/SelectMultiple';
import Submit from '../Forms/Submit';
import TextField from '../Forms/TextField';
import CloseBtn from './CloseBtn';
import ModalLayout from './ModalLayout';

interface Props { 
    user: UserType
}

function EditRole(props: Props) {
    const { user } = props

    const form = useForm({
        role_id: user?.role?.id,
        name: user.name
    });
    const { data, post } = form;

    let {open,close} = useContext(ModalsContext)

    const { all_roles: roles } = usePageProps<{ all_roles: Array<{id: number, name: string}> }>();

    useEffect(() => {
        Inertia.reload({only: ['all_roles'], preserveState: true, preserveScroll: true});
    }, [])
    

    const submit = (e) => {
        e.preventDefault();
        post(route('user.role', {user: user.id}), {onSuccess: () => close()});
    }

    return (
        <ModalLayout>
            <div className='p-20px pt-67px relative bg-gray rounded-default w-1/3 mob:w-full'>
                <CloseBtn />
                <div className='text-18 mb-12px text-white'>Editing user's role</div>
                <Form form={form} onSubmit={submit}>
                    <TextField readOnly name={'name'}  />
                    <Select name='role_id' options={roles?.map(r => ({text: r.name, value: r.id})) ?? []} />
                    <Submit className='w-full' value="Save" />
                </Form>
            </div>
        </ModalLayout>
    )
}

export default EditRole
